export default {
  title: '產品屬性',
  addFirstLevel: '新增屬性組',
  addSecondLevel: '新增屬性',
  attributeName: '屬性名稱',
  addModal: '新增屬性組',
  addSecondModal: '新增屬性',
  editModal: '編輯屬性',
  required: '請輸入屬性名稱',
};
